import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M-2-2h22v22H-2z" }),
      _createElementVNode("path", {
        fill: "#4A4A4A",
        "fill-rule": "nonzero",
        d: "M10.833 7.167H7.167v3.666h3.666zm1.834 0v3.666h2.75V7.167zm-1.834 8.25v-2.75H7.167v2.75zm1.834 0h2.75v-2.75h-2.75zM10.833 2.583H7.167v2.75h3.666zm1.834 0v2.75h2.75v-2.75zM5.333 7.167h-2.75v3.666h2.75zm0 8.25v-2.75h-2.75v2.75zm0-12.834h-2.75v2.75h2.75zM1.667.75h14.666c.507 0 .917.41.917.917v14.666c0 .507-.41.917-.917.917H1.667a.917.917 0 0 1-.917-.917V1.667c0-.507.41-.917.917-.917"
      })
    ], -1)
  ]))]))
}
export default { render: render }